import Axios from 'api/client';
import { Notification } from 'types/domain';

interface Subscription {
    type: string;
    model_type?: string | null;
    model_id?: number | null;
    channel?: string;
    subscribed: boolean;
}

interface UpdateNotificationsParams {
    subscriptions: Subscription[];
}

const fetchNotifications = (accountId: number) =>
    Axios.get<Notification[]>(`accounts/${accountId}/notifications`).then(
        response => response.data,
    );

const updateNotifications = (accountId: number, { subscriptions }: UpdateNotificationsParams) =>
    Axios.patch<Notification[]>(`accounts/${accountId}/notifications`, { subscriptions }).then(
        response => response.data,
    );

export { fetchNotifications, updateNotifications };
export type { Subscription };
